export const ImpleRef = [
    {
        ref: 'Agri Expo. (n.d.). Biolex® MB40. Retrieved October 2, 2022, from https://www.agriexpo.online/prod/leiber-gmbh/product-174959-118773.html'
    },
    {
        ref: 'Agri Expo. (n.d.). IMMUNO FORCE. Retrieved October 2, 2022, from https://www.agriexpo.online/prod/lexington/product-184817-83709.html'
    },
    {
        ref: 'Amazon. (n.d.). Dajana Immune System Booster Fish Food Flakes, 100ml/20g for All Types of Fish. Retrieved October 2, 2022, from https://www.amazon.com/Dajana-Immune-System-Booster-Flakes/dp/B01DWIBRBM'
    },
    {
        ref: 'Azaza, M. et al. (2007). Growth of Nile tilapia (Oreochromis niloticus L.) fed with diets containing graded levels of green algae ulva meal (Ulva rigida) reared in geothermal waters of southern Tunisia. Journal of Applied Ichthyology, 24(2), 202-207. 10.1111/j.1439-0426.2007.01017.x'
    },
    {
        ref: 'Beyene, T. (2016). Veterinary drug residues in food-animal products: Its risk factors and potential effects on public health. Journal of Veterinary Science & Technology, 7(1), 285. 10.4172/2157-7579.1000285'
    },
    {
        ref: 'Boyd, C. “Water temperature in aquaculture”. Global Seafood Alliance. 26 November 2018. https://www.globalseafood.org/advocate/water-temperature-in-aquaculture/'
    },
    {
        ref: 'Centre for Food Safety. (n.d.). Genetically Modified Food. Retrieved October 2, 2022, from https://www.cfs.gov.hk/english/programme/programme_gmf/programme_gmf_gi_info6.html'
    },
    {
        ref: 'Dong, X. et al. (2015). Effects of antimicrobial peptides (AMPs) on blood biochemical parameters, antioxidase activity, and immune function in the common carp (Cyprinus carpio). Fish & Shellfish Immunology, 47(1), 429-434. 10.1016/j.fsi.2015.09.030'
    },
    {
        ref: 'Echelon Biosciences. (n.d.). Cecropin B. Retrieved October 2, 2022, from https://www.echelon-inc.com/product/cecropin-b/'
    },
    {
        ref: 'Food and Agriculture Organization of the United States. “The State of World Fisheries and Aquaculture 2018—Meeting the Sustainable Development Goals”. 2018. https://www.fao.org/3/i9540en/I9540EN.pdf'
    },
    {
        ref: 'Food and Agriculture Organization of the United States. “The State of World Fisheries and Aquaculture 2020—Sustainability in Action”. 2020. https://www.fao.org/documents/card/en/c/ca9229en/'
    },
    {
        ref: 'Government of Canada. (n.d.). 5.2 Chemical residues. Retrieved October 2, 2022, from https://inspection.canada.ca/food-safety-for-industry/archived-food-guidance/meat-and-poultry-products/manual-of-procedures/chapter-5/eng/1395150894222/1395150895519?chap=2'
    },
    {
        ref: 'HKSAR Census and Statistics Department. “Hong Kong Merchandise Trade Statistics Imports”. December 2017. https://www.censtatd.gov.hk/en/data/stat_report/product/B1020001/att/B10200012017MM12B0100.pdf'
    },
    {
        ref: 'Huan, Y. et al. (2020). Antimicrobial Peptides: Classification, Design, Application and Research Progress in Multiple Fields. Frontiers in Microbiology. 10.3389/fmicb.2020.582779'
    },
    {
        ref: 'Kemin. (n.d.). AquastemTM. Retrieved October 2, 2022, from https://www.kemin.com/in/en/markets/aquaculture/products/aquastem'
    },
    {
        ref: 'Larsson, D. G. J. et al. (2018). Critical knowledge gaps and research needs related to the environmental dimensions of antibiotic resistance. Environment International, 117, 132-138. 10.1016/j.envint.2018.04.041'
    },
    {
        ref: 'Li, S. et al. (2020). Effects of antimicrobial peptides on the growth performance, antioxidant and intestinal function in juvenile largemouth bass, Micropterus salmoides. Aquaculture Reports, 16. 10.1016/j.aqrep.2019.100252'
    },
    {
        ref: 'Lu, X. et al. (2009). Preliminary investigation of chloramphenicol in fish, water and sediment from freshwater aquaculture pond. International Journal of Environmental Science & Technology, 6, 597-604. 10.1007/BF03326100'
    },
    {
        ref: 'Mustafa, M., & Nakagawa, H. (1995).  A review: Dietary benefits of algae as an additive in fish feed. Isr J Aquacult-Bamid, 46, 155-162.'
    },
    {
        ref: 'Novoslavskij, A., Terentjeva, M., Eizenberga, I. et al. (2016). Major foodborne pathogens in fish and fish products: a review. Annals of Microbiology, 66, 1-15. 10.1007/s13213-015-1102-5'
    },
    {
        ref: 'Okocha, R. et al. (2018). Food safety impacts of antimicrobial use and their residues in aquaculture. Public Health Reviews, 39(21). 10.1186/s40985-018-0099-2'
    },
    {
        ref: 'Oliveira, M. et al. (2009). Nutritive and non-nutritive attributes of washed-up seaweeds from the coast of Ceará, Brazil. Food Chemistry, 115(1), 254-259. 10.1016/j.foodchem.2008.12.004'
    },
    {
        ref: 'Romoli, O. et al. (2019). Enhanced Silkworm Cecropin B Antimicrobial Activity against Pseudomonas aeruginosa from Single Amino Acid Variation. ACS Infectious Diseases, 5(7), 1200-1213. 10.1021/acsinfecdis.9b00042'
    },
    {
        ref: 'Pękala-Safińska, A. (2018). Contemporary Threats of Bacterial Infections in Freshwater Fish. J Vet Res., 62(3), 261-267. 10.2478/jvetres-2018-0037'
    },
    {
        ref: 'Schar, D., Klein, E.Y., Laxminarayan, R. et al. (2020). Global trends in antimicrobial use in aquaculture. Scientific Reports, 10(21878). 10.1038/s41598-020-78849-3'
    },
    {
        ref: 'Su, Y. et al., (2019). Effects of antimicrobial peptides on serum biochemical parameters, antioxidant activity and non-specific immune responses in Epinephelus coioides. Fish & Shellfish Immunology, 86, 1081-1087. 10.1016/j.fsi.2018.12.056'
    },
    {
        ref: 'Tai, H. et al. (2021). Scale-up production of and dietary supplementation with the recombinant antimicrobial peptide tilapia piscidin 4 to improve growth performance in Gallus gallus domesticus. Plos One. 10.1371/journal.pone.0253661'
    },
    {
        ref: 'Wahbeh, M. (1997). Amino acid and fatty acid profiles of four species of macroalgae from Aqaba and their suitability for use in fish diets. Aquaculture, 159(1-2), 101-109. 10.1016/S0044-8486(97)00183-X'
    },
    {
        ref: 'Wang, J. et al. (2018). A novel cecropin B-derived peptide with antibacterial and potential anti-inflammatory properties. Peer J Life & Environment. 10.7717/peerj.5369'
    },
    {
        ref: 'Wang, W. “Avoid handling raw fish warning after seven die from bacterial infections”. The Standard. 21 October 2021. https://www.thestandard.com.hk/section-news/section/11/235268/Avoid-handling-raw-fish-warning-after-seven-die-from-bacterial-infections'
    },
    {
        ref: 'WHO. (2014). Evaluation of certain veterinary drug residue in food. Technical Report Series, 988, 7-32. '
    },
    {
        ref: 'WWF. (n.d.). Sustainable Seafood Overview. Retrieved October 2, 2022, from https://www.worldwildlife.org/industries/sustainable-seafood#:~:text=Approximately%203%20billion%20people%20in,to%20billions%20of%20people%20worldwide'
    },
    {
        ref: 'United States Government Accountability Office. “Seafood Safety”. April 2011. https://www.gao.gov/assets/gao-11-286.pdf'
    },
    {
        ref: 'Valente, L. et al. (2006). Evaluation of three seaweeds Gracilaria bursa-pastoris, Ulva rigida and Gracilaria cornea as dietary ingredients in European sea bass (Dicentrarchus labrax) juveniles. Aquaculture, 252(1), 85-91. 10.1016/j.aquaculture.2005.11.052'
    },
    {
        ref: 'Van Boeckel, T. P. et al. (2017). Reducing antimicrobial use in food animals. Science, 357(6358), 1350–1352. 10.1126/science.aao1495'
    },
    {
        ref: "Vaughan, A. “Global demand for fish expected to almost double by 2050”. NewScientist. 15 September 2021. https://www.newscientist.com/article/2290082-global-demand-for-fish-expected-to-almost-double-by-2050/#:~:text=The%20world's%20hunger%20for%20fish,big%20rise%20in%20farmed%20seafood."
    },
    {
        ref: 'Yokogawa. (n.d.). pH in Fish Farming. Retrieved October 2, 2022, from https://www.yokogawa.com/library/resources/application-notes/ph-in-fish-farming/'
    },
    {
        ref: 'Zhou, X. et al. (2008). Effect of feeding apidaecin on common carp (Cyprinus carpio) growth performances and immune function. Aquaculture, 279(1-4), 108-112. 10.1016/j.aquaculture.2008.04.024'
    },

]
